import React from 'react';
import { Link } from 'gatsby';
import { LogoSystemGuiden } from '../../../../../static/icons/iconGuide';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';

const SystemGuideCard = ({ heading, text, buttonText, buttonHref }) => (
  <Link
    to={buttonHref}
    className="cursor-pointer transition ease-in-out hover:translate-y-2 hover:scale-110 box-border bg-white px-5 py-5 sm:py-10 rounded-3xl border-primary-800 border-8"
  >
    <Stack className="gap-3 items-center">
      <div className="flex justify-center">
        <LogoSystemGuiden />
      </div>
      <Typography as="h3" fontVariant="h6">
        {heading}
      </Typography>
      <Typography
        fontVariant="md"
        className="!text-customGray-600 w-[250px] sm:w-[280px]"
      >
        {text}
      </Typography>
      <LinkButton
        // href={buttonHref}
        title={buttonText}
        label={buttonText}
        size="lg"
        className="w-fit font-medium px-6 py-2"
        variant="primary-filled"
        textTransform="uppercase"
      />
    </Stack>
  </Link>
);

export default SystemGuideCard;
